export const formatCurrency = (value, notation = 'standard') =>
  new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', notation }).format(value).replace(/\D00$/, '');
